var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpFrame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#10283a;}.cls-2{fill:#173856;}.cls-3{fill:#fbbcaa;}.cls-4{fill:#20456e;}.cls-5{fill:#00a891;}.cls-6{fill:#442114;}.cls-7{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "frame 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "haut_4_m",
    "data-name": "haut 4 m"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "479.41 895 479.41 965 412.41 965 412.41 891 479.41 895"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1007.41,1248l2,183c6-48,95-51,99-1l-11-178Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1108.41,1430v79c0,35.19-99,35.19-99,0v-75C1007.26,1380.76,1106.26,1376.76,1108.41,1430Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M916.41,1252l5,287c0,14,80,14,80,0l8.67-199.1-2.42-87.9Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1140,1198.8c-5.12-18.42-62.12-6.06-57,12.37,0,0,3,33.56,37,28.26S1140,1198.8,1140,1198.8Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1083,1019.54c22.58.39,40.5,9.34,49,35.46l12,135c0,36-58,40-58,13Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1097.59,1252.5v-203s0-50-90.59-50-90.59,40-90.59,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 916.41,
    y: 1244,
    width: 181,
    height: 9,
    transform: "translate(1496.82 1886) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M815,836.19c14-20.19,23.41-3.79,23.41-5.69a169,169,0,0,1,168.59-169h.41A169,169,0,0,1,1176,830.5c0,1.9,9.41-14.5,23.41,5.69,7.72,11.13,8.89,57.77-9,76.81-14.55,15.49-33,24-45.38,15a168.78,168.78,0,0,1-137.62,71.45H1007A168.78,168.78,0,0,1,869.38,928c-12.38,9-30.83.45-45.38-15C806.11,894,807.28,847.32,815,836.19Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M824.81,788c13.32-102.49,102.36-142.91,182.85-140.59,80.49-2.32,169.52,38.1,182.84,140.59,1.91,42-5.09,39-15.09,42-8.21,33.38-14.41,77-32,100a223.08,223.08,0,0,1-24.17,27,169.09,169.09,0,0,1-43.83,30c-31.06,15-54,14-67.75,12.8-13.73,1.25-36.7,2.15-67.76-12.8a169.25,169.25,0,0,1-43.83-30,223.08,223.08,0,0,1-24.17-27c-17.59-23-23.78-66.62-32-100C829.9,827,822.9,830,824.81,788Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1005.41,1000c27.21-1,45.68,2.64,60,9.5-13.68,11-34.88,10.5-60,10.5s-46.32.48-60-10.5C959.74,1002.64,978.21,999,1005.41,1000Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M933,1016.54c-22.58.39-40.5,9.34-49,35.46l-28,148c14,24,49,33,62,18Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M865.25,1209c1.24-8.77,45.49,3.82,44.82,11,0,0-2.36,29.89-29.1,25.17S865.25,1209,865.25,1209Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpFrame4);
export default __webpack_public_path__ + "static/media/up_frame_4.c124da037746e2b9a458f92cab6f7184.svg";
export { ForwardRef as ReactComponent };